export default "__VITE_ASSET__GDB84nbh__"